import { CustomRoute } from '@app/components/layout/sidebar/components/route';
import { Outlet, Route } from 'react-router-dom';
import ProductionReportPage from './production-report-page';
import PurchasingReportPage from './purchasing-report-page';
import ReportsPage from './reports-list-page';
import SalesReportPage from './sales-report-page';

export const reportRoutes = {
  REPORTS: '/reports',
  SALES_REPORT: '/reports/sales/:report_id',
  PURCHASING_REPORT: '/reports/purchasing/:report_id',
  PRODUCTION_REPORT: '/reports/production/:report_id',
};

export function ReportRoutes() {
  return (
    <Route element={<CustomRoute hasSidebar element={<Outlet />} />}>
      <Route path={reportRoutes.REPORTS} element={<ReportsPage />} />
      <Route path={reportRoutes.SALES_REPORT} element={<SalesReportPage />} />
      <Route
        path={reportRoutes.PURCHASING_REPORT}
        element={<PurchasingReportPage />}
      />
      <Route
        path={reportRoutes.PRODUCTION_REPORT}
        element={<ProductionReportPage />}
      />
    </Route>
  );
}
